class Toolbarmobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.activate();
    this.setHeight();

    this.boundSetHeight = () => this.setHeight();
    window.addEventListener('resize', this.boundSetHeight, { passive: true });

    this.lastScrollTop = 0;
    this.scrollThreshold = 6;
    
    this.boundScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      
      // Always show toolbar at the top of the page
      if (scrollTop <= 50) {
        this.classList.remove('toolbar-hidden');
        this.lastScrollTop = scrollTop;
        return;
      }
      
      // Determine scroll direction
      if (Math.abs(scrollTop - this.lastScrollTop) > this.scrollThreshold) {
        if (scrollTop > this.lastScrollTop) {
          // Scroll Down -> Hide Toolbar
          this.classList.add('toolbar-hidden');
        } else {
          // Scroll Up -> Show Toolbar
          this.classList.remove('toolbar-hidden');
        }
      }
      
      this.lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', this.boundScroll, { passive: true });
  }

  disconnectedCallback() {
    if (this.boundSetHeight) window.removeEventListener('resize', this.boundSetHeight);
    if (this.boundScroll) window.removeEventListener('scroll', this.boundScroll);
  }

  activate() {
    // Keep it active by default so it shows on initial load
    this.classList.add("active");
  }

  setHeight() {
    if (this.clientHeight > 0) {
      document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
    }
  }
}

if (!customElements.get("toolbar-mobile")) {
  customElements.define("toolbar-mobile", Toolbarmobile);
}
